import {
  Grid,
  MenuItem,
  TextField,
  Typography,
  Checkbox,
  FormControlLabel,
  CircularProgress,
  Autocomplete
} from "@mui/material";

const RowDetails = ({
  title,
  value,
  name,
  type = "text",
  options = [],
  error,
  disabled,
  onChange,
  addressOptions = [],
  addressLoading = false,
  onAddressSearch,
  onAddressSelect,
}) => {
  console.log({value});
  
  return (
    <Grid container spacing={1}>
      <Grid size={{ xs: 12, sm: 5 }}>
        <Typography variant="caption">{title}</Typography>
      </Grid>

      <Grid size={{ xs: 12, sm: 7 }}>
        {type === "address-autocomplete" && (
          <Autocomplete
            fullWidth
            freeSolo
            value={value}
            options={addressOptions}
            loading={addressLoading}
            getOptionLabel={(option) => option?.name || ""}
            isOptionEqualToValue={(option, value) =>
              option?.id === value?.id
            }
            onInputChange={(_, newInputValue) => {
              onAddressSearch?.(newInputValue);
            }}
            onChange={(_, newValue) => {
              onAddressSelect?.(name, newValue ? newValue.id : null);
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                size="small"
                error={Boolean(error)}
                helperText={error}
                InputProps={{
                  ...params.InputProps,
                  endAdornment: (
                    <>
                      {addressLoading ? (
                        <CircularProgress size={18} />
                      ) : null}
                      {params.InputProps.endAdornment}
                    </>
                  ),
                }}
              />
            )}
          />
        )}

        {type === "checkbox" && (
          <FormControlLabel
            control={
              <Checkbox
                size="small"
                checked={Boolean(value)}
                disabled={disabled}
                onChange={(e) => onChange(name, e.target.checked)}
              />
            }
            label=""
          />
        )}

        {type !== "checkbox" && type !== "address-autocomplete" && (
          <TextField
            name={name}
            select={type === "select"}
            fullWidth
            size="small"
            value={value ?? ""}
            error={Boolean(error)}
            helperText={error}
            disabled={disabled}
            onChange={(e) => onChange(name, e.target.value)}
          >
            {type === "select" &&
              options.map((opt) => (
                <MenuItem key={opt.value} value={opt.value}>
                  {opt.label}
                </MenuItem>
              ))}
          </TextField>
        )}
      </Grid>
    </Grid>
  );
};

export default RowDetails;
